/* DESPI — pages preview + customize (flux post-génération)
   Retry / Edit relancent une vraie génération via window.despiApi.
   Add to cart emmene directement au checkout Shopify (plus de detour par le panier). */
(function () {
  'use strict';

  /* ---------- preview.html : versions + retry/edit ---------- */
  var versions = document.querySelector('[data-flow-versions]');
  if (versions) {
    var portrait = document.querySelector('[data-flow-portrait]');

    /* ---- portrait reel, designe par ?id= dans l'URL ----
       Comme chez TMR, la generation est identifiee dans l'adresse de la page : la cliente
       peut la partager ou y revenir, et le portrait se retrouve sans compte. Si l'id est
       absent, on garde la demonstration — utile pour travailler la page sans generer. */
    var genId = new URLSearchParams(location.search).get('id');
    var galerie = [];   // les versions successives, la derniere en premier
    var courant = null; // adresse D'ORIGINE affichee — jamais l'adresse transformee

    /* ---- le style voyage dans l'adresse ----
       La page du portrait est COMMUNE a tous les styles : elle ne montre que le tirage.
       Mais la suite du parcours, elle, ne l'est pas — le configurateur a une page par
       style, avec le bon titre de produit et la bonne description. C'est donc l'adresse
       qui transporte le style depuis la page de creation. Sans lui, une cliente venue par
       une annonce memoriale lisait « Wild Pirates - Custom Portrait » au moment de payer. */
    if (window.despiApi) {
      window.despiApi.definirStyle(new URLSearchParams(location.search).get('style'));
    }

    /* Le CDN de Supabase redimensionne a la volee : on ne demande jamais plus large que
       ce qui est reellement affiche. `galerie` garde les adresses D'ORIGINE — c'est au
       moment de poser une image qu'on choisit sa taille, le grand portrait et sa vignette
       de 65 px n'ayant pas les memes besoins. */
    function adressePortrait(url) {
      if (!window.despiApi || !window.despiApi.image) return url;
      // largeur reelle du cadre, avec la fenetre en repli avant la mise en page
      var l = (portrait && portrait.clientWidth) || window.innerWidth || 500;
      return window.despiApi.image(url, l);
    }
    function adresseVignette(url) {
      if (!window.despiApi || !window.despiApi.image) return url;
      return window.despiApi.image(url, 65);   // 65 px, la taille du bouton de version
    }

    /* ---- le lien vers le configurateur porte TOUJOURS le portrait affiche ----

       Ce lien etait ecrit en dur dans le HTML (`href="customize.html"`), traduit par le
       build en `/pages/despi-customize` — sans identifiant. Consequences en chaine, toutes
       mesurees : le configurateur montrait le portrait de la demonstration, l'ajout au
       panier enregistrait `generationId: null`, et le bouton de paiement, qui ecarte les
       articles sans identifiant, ne faisait plus RIEN. Aucune vente n'etait possible.

       Le lien est donc pose ici, comme toutes les autres navigations. Et il suit la version
       REELLEMENT AFFICHEE : la galerie permet de revenir a une version precedente sans
       changer `genId`, ce qui aurait envoye a l'impression une autre image que celle
       choisie. L'identifiant se lit dans l'adresse du portrait, qui le contient. */
    function idDepuisUrl(u) {
      var m = String(u || '').match(/generations\/([0-9a-fA-F-]{36})\//);
      return m ? m[1] : null;
    }

    function majLienCustomize() {
      var a = document.querySelector('[data-flow-customize]');
      if (!a || !window.despiApi) return;
      var id = idDepuisUrl(courant) || genId;
      // sans portrait, il n'y a rien a configurer : on renvoie la ou on en fabrique un
      a.setAttribute('href', id
        ? window.despiApi.lien('customize', { id: id })
        : window.despiApi.page('create'));
    }

    /* Gestes d'enregistrement bloques sur l'apercu.
       A ETRE CLAIR SUR CE QUE CA VAUT : ca arrete le clic droit, le glisser-deposer et
       l'appui long iOS — les gestes ordinaires. Ca n'empeche RIEN a quelqu'un qui ouvre
       l'onglet Reseau ou fait une capture d'ecran : l'image doit arriver au navigateur
       pour s'afficher, c'est une impossibilite technique et non un manque de soin. La
       seule protection reelle d'un apercu gratuit reste le filigrane. */
    (function protegerApercu() {
      if (!portrait) return;
      portrait.setAttribute('draggable', 'false');
      portrait.style.webkitTouchCallout = 'none';   // iOS : supprime « Enregistrer l'image »
      portrait.style.userSelect = 'none';
      portrait.style.webkitUserSelect = 'none';
      portrait.style.pointerEvents = 'none';        // les gestes tombent sur le cadre, pas sur l'image
      var cadre = portrait.parentElement;
      if (cadre) {
        cadre.addEventListener('contextmenu', function (e) { e.preventDefault(); });
        cadre.addEventListener('dragstart', function (e) { e.preventDefault(); });
      }
    })();

    function poserPortrait(url, ajouter) {
      if (!url) return;
      courant = url;
      /* Le fond d'attente ne se leve qu'une fois le portrait REELLEMENT charge. Cette page
         livrait `demo-portrait.jpg` — le visage d une inconnue — sous un `alt="Your pirate
         portrait"`, affiche pendant tout l'appel reseau. C'est l'ecran qui suit la
         generation : le moment ou la cliente decouvre SON portrait. Y montrer celui de
         quelqu'un d'autre, meme une seconde, casse exactement ce qu'on vient de construire. */
      portrait.onload = function () {
        var boite = portrait.closest('[data-flow-portrait-boite]');
        if (boite) boite.classList.remove('dp-portrait-attente');
      };
      portrait.src = adressePortrait(url);
      if (ajouter !== false && galerie.indexOf(url) < 0) galerie.unshift(url);
      dessinerVersions();
      majLienCustomize();
      // Le portrait est a l'ecran : c'est le signal d'intention le plus fort du parcours,
      // et le seul que Shopify ne sait pas produire. Une cle par generation evite de le
      // recompter au rechargement ou au retour arriere.
      if (window.despiTrack) window.despiTrack.portraitAffiche(genId);
    }

    function dessinerVersions() {
      var compteur = document.querySelector('[data-flow-versions-count]');
      if (compteur) compteur.textContent = 'See all (' + Math.max(1, galerie.length) + ')';
      if (galerie.length < 2) { versions.innerHTML = ''; return; }
      versions.innerHTML = galerie.map(function (u, i) {
        // on compare les adresses D'ORIGINE : deux appels a adressePortrait() peuvent
        // rendre des largeurs differentes selon l'etat de la mise en page, et la
        // comparaison d'adresses transformees casserait le surlignage.
        return '<button type="button" data-src="' + u + '" class="relative w-[65px] h-[65px] rounded-[12px] shrink-0 cursor-pointer border-2 transition-colors '
          + (u === courant ? 'border-text-primary' : 'border-transparent')
          + '"><span class="absolute inset-0 rounded-[10px] overflow-hidden"><img src="' + adresseVignette(u)
          + '" alt="Portrait variant ' + (i + 1) + '" class="w-full h-full object-cover select-none" draggable="false"></span></button>';
      }).join('');
    }

    // Des le chargement, avant meme que le portrait n'arrive : une cliente qui clique vite
    // ne doit pas partir avec le lien d'origine, qui ne porte aucun identifiant.
    majLienCustomize();

    if (genId && window.despiApi) {
      // On arrive ici juste apres la generation : l'image est deja prete la plupart du
      // temps, d'ou le premier appel direct. L'overlay n'apparait que si elle ne l'est
      // pas encore — page rechargee, lien partage, generation reprise.
      var ovInitial = null;
      window.despiApi.attendre(genId, function (s) {
        if (s.status !== 'COMPLETED' && !ovInitial && window.despiOverlay) {
          ovInitial = window.despiOverlay();
        }
        if (ovInitial) ovInitial.progresser(s.progress || 0);
      }).then(function (s) {
        if (ovInitial) { ovInitial.terminer(); setTimeout(ovInitial.fermer, 400); }
        poserPortrait(s.previewUrl);
      }).catch(function () {
        if (ovInitial) ovInitial.echouer('This portrait is no longer available');
        else if (window.despiToast) window.despiToast('This portrait is no longer available.');
      });
    }
    versions.addEventListener('click', function (e) {
      var btn = e.target.closest('button[data-src]');
      if (!btn) return;
      // data-src porte l'adresse D'ORIGINE : on repasse par adressePortrait() pour
      // afficher le grand format, sinon on agrandirait la vignette de 65 px.
      courant = btn.getAttribute('data-src');
      portrait.src = adressePortrait(courant);
      // la cliente vient de choisir SA version : c'est celle-la qui doit partir au
      // configurateur, pas la derniere generee
      majLienCustomize();
      [...versions.querySelectorAll('button')].forEach(function (b) {
        b.classList.toggle('border-text-primary', b === btn);
        b.classList.toggle('border-transparent', b !== btn);
      });
    });
    /* ---- bottom sheets Retry / Edit (markup TMR) ---- */
    /* Le catalogue de styles vient du serveur (window.despiApi.styles), jamais d'ici.
       Voir despi-backend/CATALOGUE-STYLES.md pour la disposition d'origine des seize
       emplacements et la marche a suivre pour en rouvrir un. */
    var openSheet = null;

    function closeSheet() {
      if (!openSheet) return;
      var sh = openSheet;
      openSheet = null;
      sh.querySelector('[data-sheet-backdrop]').style.opacity = '0';
      sh.querySelector('[data-sheet-panel]').style.transform = 'translateY(100%)';
      document.body.style.overflow = '';
      setTimeout(function () { sh.remove(); }, 300);
    }

    function buildSheet(title, bodyHTML) {
      var sh = document.createElement('div');
      sh.className = 'fixed inset-0 z-[60]';
      sh.setAttribute('aria-modal', 'true');
      sh.setAttribute('role', 'dialog');
      sh.innerHTML =
        '<div data-sheet-backdrop class="absolute inset-0 bg-black/40 transition-opacity duration-[260ms]" style="opacity:0"></div>' +
        '<div data-sheet-panel class="theme-tmr absolute bottom-0 left-0 right-0 bg-text-on-dark rounded-t-[20px] max-h-[88vh] flex flex-col shadow-[0_-8px_32px_rgba(0,0,0,0.18)]" style="transform:translateY(100%);transition:transform 280ms cubic-bezier(0.32,0.72,0,1)">' +
          '<div class="flex justify-center pt-3 pb-2 cursor-grab active:cursor-grabbing touch-none"><div class="w-9 h-1 rounded-full bg-border-primary"></div></div>' +
          '<div class="relative flex items-center justify-center px-4 pb-3"><h2 class="font-barlow font-semibold italic text-[18px] leading-6 text-text-primary">' + title + '</h2></div>' +
          '<div class="overflow-y-auto overscroll-contain px-4 pb-6">' + bodyHTML + '</div>' +
        '</div>';
      document.body.appendChild(sh);
      document.body.style.overflow = 'hidden';
      openSheet = sh;
      setTimeout(function () {
        sh.querySelector('[data-sheet-backdrop]').style.opacity = '1';
        sh.querySelector('[data-sheet-panel]').style.transform = 'translateY(0)';
      }, 20);
      sh.querySelector('[data-sheet-backdrop]').addEventListener('click', closeSheet);
      return sh;
    }

    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSheet(); });

    var ICON_REGEN = '<svg class="w-5 h-5 text-text-primary" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.992 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182"></path></svg>';
    var ICON_UPLOAD = '<svg class="w-5 h-5 text-text-primary" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5m-13.5-9L12 3m0 0l4.5 4.5M12 3v13.5"></path></svg>';

    function sheetOption(icon, title, sub, action) {
      return '<button type="button" data-sheet-action="' + action + '" class="flex items-center gap-3 w-full p-4 rounded-[12px] bg-white border border-border-primary text-left disabled:opacity-50 cursor-pointer">' +
        '<div class="w-10 h-10 rounded-full bg-bg-secondary flex items-center justify-center shrink-0">' + icon + '</div>' +
        '<div class="flex flex-col"><span class="font-semibold text-base leading-5 text-text-primary">' + title + '</span>' +
        '<span class="text-sm leading-5 text-text-tertiary">' + sub + '</span></div></button>';
    }

    /**
     * Relance une generation a partir des MEMES photos, sans les renvoyer : le backend
     * les retrouve par leurs identifiants et resigne leurs adresses. Le nouveau portrait
     * s'ajoute a la galerie de versions plutot que de remplacer l'ancien — la cliente
     * peut comparer et revenir en arriere, comme chez TMR.
     */
    var relanceEnCours = false;
    function relancer(opts) {
      if (relanceEnCours || !genId || !window.despiApi) return;
      relanceEnCours = true;

      // Meme overlay que la premiere generation : barre de progression, avis defilants.
      // Sans lui la page paraissait simplement figee et la cliente ne comprenait pas
      // qu'une nouvelle version etait partie.
      var ov = window.despiOverlay ? window.despiOverlay() : null;
      if (ov) ov.progresser(5);

      window.despiApi.generer({
        styleSlug: opts && opts.styleSlug,       // absent = on garde le style d'origine
        personalize: (opts && opts.personalize) || '',
        fromGeneration: genId,
      }).then(function (gen) {
        genId = gen.generationId;
        // Changer de style change la suite du parcours : le configurateur doit decrire le
        // style REELLEMENT choisi, pas celui de la page d'arrivee. On le note avant de
        // reecrire l'adresse et de reposer le lien, qui en dependent tous les deux.
        if (opts && opts.styleSlug) window.despiApi.definirStyle(opts.styleSlug);
        history.replaceState(null, '', window.despiApi.lien('preview', { id: genId, style: window.despiApi.style() }));
        majLienCustomize();
        if (ov) ov.progresser(12);
        return window.despiApi.attendre(genId, function (s) {
          if (ov) ov.progresser(12 + (s.progress || 0) * 0.88);
        });
      }).then(function (s2) {
        relanceEnCours = false;
        // on precharge avant de fermer : l'overlay ne doit pas laisser voir l'ancien
        var img = new Image();
        img.onload = img.onerror = function () {
          if (ov) { ov.terminer(); setTimeout(ov.fermer, 400); }
          poserPortrait(s2.previewUrl);
        };
        // meme adresse que celle qui sera affichee : sinon l'image part deux fois
        img.src = adressePortrait(s2.previewUrl);
      }).catch(function (e) {
        relanceEnCours = false;
        var info = window.despiMessageErreur(e);
        // ici la cliente n'a pas de champ d'envoi sous la main : l'action la ramene a la
        // page ou elle pourra reprendre avec une autre photo
        if (info.action) {
          info.onAction = function () { window.location.href = window.despiApi.page('create'); };
        }
        if (ov) ov.echouer(info);
        else if (window.despiToast) window.despiToast(info.msg);
      });
    }

    document.querySelector('[data-flow-retry]').addEventListener('click', function () {
      var body = '<div class="flex flex-col gap-3 pt-1">' +
        sheetOption(ICON_REGEN, 'Regenerate portrait', 'Same photo, new result', 'regenerate') +
        sheetOption(ICON_UPLOAD, 'Upload new photo', 'Start fresh with different photo', 'upload') +
        '</div>';
      var sh = buildSheet('Retry portrait', body);
      sh.addEventListener('click', function (e) {
        var b = e.target.closest('[data-sheet-action]');
        if (!b) return;
        closeSheet();
        var action = b.getAttribute('data-sheet-action');
        setTimeout(function () {
          if (action === 'upload') window.location.href = window.despiApi.page('create');
          else relancer();
        }, 320);
      });
    });

    /* Echappement obligatoire : les noms viennent du serveur et sont inseres en HTML. */
    function txt(s) {
      return String(s == null ? '' : s)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }

    function carteStyle(s) {
      return '<button type="button" data-style="' + txt(s.slug) + '" class="flex flex-col items-start shrink-0 cursor-pointer w-[120px]">' +
        '<div class="relative w-full aspect-[1208/1496] overflow-hidden rounded-[12px] bg-bg-card">' +
          '<img alt="' + txt(s.name) + '" loading="lazy" decoding="async" class="object-cover" style="position:absolute;height:100%;width:100%;inset:0" src="' + txt(s.img) + '">' +
        '</div>' +
        '<span class="mt-2 text-sm font-semibold leading-5 text-text-primary truncate w-full text-left">' + txt(s.name) + '</span></button>';
    }

    /* Trois cartes grises pendant le chargement : elles reservent la hauteur exacte du
       carrousel, sinon le panneau sauterait sous le doigt de la cliente a l'arrivee de
       la liste. Retirees ensuite, avec tout le bloc s'il n'y a rien a proposer. */
    var CARTE_VIDE = '<div class="shrink-0 w-[120px]">' +
      '<div class="w-full aspect-[1208/1496] rounded-[12px] bg-bg-card"></div>' +
      '<div class="mt-2 h-5 rounded bg-bg-card"></div></div>';
    var SQUELETTE = CARTE_VIDE + CARTE_VIDE + CARTE_VIDE;

    document.querySelector('[data-flow-edit]').addEventListener('click', function () {
      var cards = SQUELETTE;
      var body = '<div class="flex flex-col gap-4 pt-1">' +
        '<div data-styles-bloc class="-mx-4 px-4">' +
          '<div class="flex items-center gap-1.5 mb-2">' +
            '<svg class="w-4 h-4 text-text-tertiary" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24"><circle cx="12" cy="12" r="9"></circle><circle cx="9" cy="9.5" r="0.6" fill="currentColor"></circle><circle cx="14.5" cy="8" r="0.6" fill="currentColor"></circle><circle cx="16" cy="13" r="0.6" fill="currentColor"></circle><circle cx="11" cy="15.5" r="0.6" fill="currentColor"></circle></svg>' +
            '<span class="text-xs font-semibold uppercase tracking-wide text-text-tertiary">Switch style</span>' +
          '</div>' +
          '<div class="overflow-x-auto overflow-y-hidden touch-pan-x py-1 -mx-1 px-1 scrollbar-hide"><div data-styles-piste class="flex gap-3 pr-4">' + cards + '</div></div>' +
        '</div>' +
        '<div class="flex flex-col gap-2">' +
          '<div class="flex items-center gap-1.5">' +
            '<svg class="w-4 h-4 text-text-tertiary" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L6.832 19.82a4.5 4.5 0 01-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 011.13-1.897L16.863 4.487z"></path></svg>' +
            '<span class="text-xs font-semibold uppercase tracking-wide text-text-tertiary">Describe changes</span>' +
          '</div>' +
          '<div class="flex items-center bg-white border border-border-primary rounded-[12px] pl-4 pr-2 py-2">' +
            '<input data-sheet-personalize placeholder="Personalize - add a parrot…" class="flex-1 bg-transparent text-base leading-6 text-text-primary placeholder:text-text-tertiary outline-none" type="text" value="">' +
            '<span class="shrink-0 px-2 py-1 rounded-full bg-border-primary text-xs text-text-tertiary">optional</span>' +
          '</div>' +
        '</div>' +
        '<button type="button" data-sheet-submit class="flex items-center justify-center gap-2 w-full py-3 rounded-full bg-bg-tertiary text-text-on-dark font-semibold text-base leading-6 disabled:opacity-50 disabled:cursor-not-allowed">Edit your masterpiece</button>' +
        '</div>';
      var sh = buildSheet('Edit your masterpiece', body);
      var chosen = null;

      /* Remplissage par le serveur. Le panneau s'ouvre AVANT la reponse : faire attendre
         la cliente devant un ecran vide couterait plus qu'un carrousel qui se remplit.
         Zero style publiable -> le bloc entier disparait, et « Describe changes » reste
         utilisable seul. Mieux vaut une option en moins qu'une option qui ne marche pas. */
      var bloc = sh.querySelector('[data-styles-bloc]');
      var piste = sh.querySelector('[data-styles-piste]');
      window.despiApi.styles().then(function (liste) {
        if (!sh.isConnected) return;                 // panneau deja referme
        // moins de deux styles = aucun choix a offrir : le portrait affiche est deja dans
        // le seul style existant. On retire le bloc plutot que de montrer une case unique.
        if (liste.length < 2) { if (bloc) bloc.remove(); return; }
        if (piste) piste.innerHTML = liste.map(carteStyle).join('');
      });

      // drag-souris sur le carrousel de styles (le swipe tactile est natif)
      var track = sh.querySelector('.overflow-x-auto');
      if (track) {
        var down = false, sx = 0, sl = 0, moved = false;
        track.style.cursor = 'grab';
        track.addEventListener('pointerdown', function (e) {
          if (e.pointerType === 'touch') return;
          down = true; moved = false;
          sx = e.clientX; sl = track.scrollLeft;
          track.style.cursor = 'grabbing';
        });
        window.addEventListener('pointermove', function (e) {
          if (!down) return;
          var dx = e.clientX - sx;
          if (Math.abs(dx) > 5) moved = true;
          track.scrollLeft = sl - dx;
        });
        window.addEventListener('pointerup', function () {
          if (!down) return;
          down = false;
          track.style.cursor = 'grab';
          setTimeout(function () { moved = false; }, 40);
        });
        track.addEventListener('click', function (e) {
          if (moved) { e.stopPropagation(); e.preventDefault(); }
        }, true);
      }
      sh.addEventListener('click', function (e) {
        var card = e.target.closest('[data-style]');
        if (card) {
          chosen = card.getAttribute('data-style');
          sh.querySelectorAll('[data-style] > div').forEach(function (d) {
            d.className = 'relative w-full aspect-[1208/1496] overflow-hidden rounded-[12px] bg-bg-card';
          });
          card.querySelector('div').className = 'relative w-full aspect-[1208/1496] overflow-hidden rounded-[12px] bg-bg-card ring-2 ring-accent-primary';
          return;
        }
        if (e.target.closest('[data-sheet-submit]')) {
          var champ = sh.querySelector('[data-sheet-personalize]');
          var instructions = champ ? champ.value.trim() : '';
          closeSheet();
          setTimeout(function () { relancer({ styleSlug: chosen, personalize: instructions }); }, 320);
        }
      });
    });
  }

  /* ---------- customize.html : configurateur ---------- */
  var sizesGrid = document.querySelector('[data-flow-sizes]');
  if (!sizesGrid) return;

  // data prix (relevés sur le site réel)
  var PRICING = {
    poster: {
      framePrice: 50,
      sizes: [
        { in: '12 × 16', cm: '30 × 40', old: 109, price: 44 },
        { in: '18 × 24', cm: '45 × 60', old: 149, price: 59, best: true },
        { in: '24 × 36', cm: '60 × 90', old: 199, price: 77 }
      ]
    },
    canvas: {
      framePrice: 49,
      sizes: [
        { in: '8 × 10', cm: '20 × 25', old: 199, price: 79 },
        { in: '12 × 16', cm: '30 × 40', old: 249, price: 99 },
        { in: '18 × 24', cm: '45 × 60', old: 299, price: 119, best: true },
        { in: '24 × 36', cm: '60 × 90', old: 399, price: 159 }
      ]
    }
  };
  var DIGITAL_ONLY = 49;

  // option bois par format — fidele au produit Printful reellement livre
  // poster encadre -> "Red Oak" (chene clair) ; canvas encadre -> "Brown" (noyer sombre)
  var WOOD_META = {
    poster: { label: 'Oak', img: ''+(window.DESPI_ASSET_BASE||'')+'dp-img-customize-oak.jpg' },
    canvas: { label: 'Walnut', img: ''+(window.DESPI_ASSET_BASE||'')+'dp-img-customize-walnut.jpg' }
  };

  /* ---- combinaisons retirees de la vente ----

     Le poster 24x36 encadre est le seul produit du catalogue ou l'option DETRUIT de la
     marge : le cadre coute 57 $ de production et 19,30 $ de port supplementaire, pour 50 $
     factures — 26 $ perdus par rapport au meme poster vendu nu. Plutot que d'augmenter le
     supplement sur cette seule taille, on l'affiche en rupture : c'est plus lisible pour la
     cliente qu'un prix qui bondit sans raison apparente.

     Le controle existe AUSSI cote serveur : ceci n'est que l'affichage. */
  var INDISPONIBLE = { 'poster|24x36|black': true, 'poster|24x36|walnut': true };

  function estIndisponible(format, sizeIdx, frame) {
    var t = PRICING[format].sizes[sizeIdx];
    var taille = t['in'].replace(/\s/g, '').replace('×', 'x');
    return !!INDISPONIBLE[format + '|' + taille + '|' + frame];
  }

  var state = { format: 'poster', frame: 'none', sizeIdx: 0, unit: 'in', digitalOnly: false };

  /* L'adresse du portrait n'est utile qu'au cas « fichier numerique seul », ou l'on montre
     le portrait sans support. Pour tous les autres, le compositeur travaille a partir du
     seul identifiant : rien a charger ici. Un echec laisse simplement le visuel de repli. */
  (function chargerPortrait() {
    var id = new URLSearchParams(location.search).get('id');
    if (!id || !window.despiApi) return;
    window.despiApi.etat(id).then(function (s) {
      if (!s || !s.previewUrl) return;
      portraitCliente = s.previewUrl;
      render();
    }).catch(function () { /* le repli reste affiche */ });
  })();

  function money(n) { return '$' + n; }

  function renderSizes() {
    var conf = PRICING[state.format];
    sizesGrid.className = 'grid gap-2 ' + (conf.sizes.length === 4 ? 'grid-cols-2 lg:grid-cols-4' : 'grid-cols-3');
    sizesGrid.innerHTML = conf.sizes.map(function (s, i) {
      var sel = i === state.sizeIdx;
      var label = state.unit === 'in' ? s.in : s.cm;
      return '<button type="button" data-size="' + i + '" aria-pressed="' + sel + '" class="relative flex-1 min-w-0 text-left cursor-pointer">' +
        '<span class="block h-full overflow-hidden rounded-lg transition-colors ' +
          (sel ? 'bg-accent-primary-muted border border-accent-primary-muted-hover' : 'bg-bg-primary border border-border-subtle hover:border-border-primary') + '">' +
          '<span class="flex flex-col gap-1 items-center text-center p-3 lg:px-4 whitespace-nowrap">' +
            '<span class="text-sm lg:text-base text-text-primary font-semibold tracking-[-0.04em]" style="font-family:var(--font-barlow-display), var(--font-barlow), serif">' + label + '</span>' +
            '<span class="flex items-center gap-1 lg:gap-2">' +
              '<span class="text-[10px] leading-3 lg:text-xs lg:leading-4 text-text-tertiary line-through">' + money(s.old) + '</span>' +
              '<span class="text-xs lg:text-sm font-semibold text-text-primary">' + money(s.price) + '</span>' +
            '</span></span></span>' +
        (sel ? '<span class="pointer-events-none absolute inset-0 rounded-lg border-2 border-accent-primary-muted-hover" aria-hidden="true"></span>' : '') +
        (s.best ? '<span class="absolute -top-3 left-1/2 -translate-x-1/2 rounded-full bg-accent-primary text-text-on-dark px-1.5 py-1 text-[10px] leading-3 font-semibold whitespace-nowrap" aria-hidden="true">BEST SELLER</span>' : '') +
        '</button>';
    }).join('');
  }

  function total() {
    if (state.digitalOnly) return DIGITAL_ONLY;
    var conf = PRICING[state.format];
    var t = conf.sizes[state.sizeIdx].price;
    if (state.frame !== 'none') t += conf.framePrice;
    return t;
  }

  function frameLabel() {
    if (state.frame === 'none') return 'No frame';
    if (state.frame === 'black') return 'Black frame';
    return WOOD_META[state.format].label + ' frame';
  }

  var VIEWER = document.querySelector('[data-flow-viewer]');

  /* ------------------------------------------- le portrait de la cliente dans le support

     Cette page etait le trou du parcours : la cliente y choisit son format et engage 44 a
     208 $, et le visuel montrait un mockup ou le portrait d'une AUTRE personne est incruste
     dans le JPEG — avec `alt="Your portrait"` par-dessus le marche. Son propre portrait
     n'etait tout simplement jamais charge ici (aucun appel a l'API dans tout ce bloc).

     On superpose donc son portrait dans la zone reservee des mockups `mockup-*.jpg`, dont
     l'emplacement du tableau est laisse VIDE a la generation. Les coordonnees viennent du
     script qui fabrique ces images : zone en pourcentages, donc valable a toute taille
     d'ecran. Le ratio de la zone (3:4) est celui des portraits : `cover` ne rogne rien de
     visible.

     REPLI. Sans portrait — page ouverte sans identifiant, generation expiree, reseau coupe
     — on garde les anciens mockups a portrait incruste : moins juste, mais toujours plus
     presentable qu'un cadre vide. On ne degrade jamais l'existant. */
  /* ------------------------------------- le portrait de la cliente dans son support

     Cette page etait le trou du parcours : la cliente y choisit son format et engage 44 a
     208 $, et le visuel montrait un mockup ou le portrait d'une AUTRE personne est incruste
     dans le JPEG — avec `alt="Your portrait"` par-dessus le marche.

     METHODE REPRISE DE TURN ME ROYAL, relevee sur leur production : le support n'est pas
     empile en CSS, il est COMPOSE PAR LE SERVEUR et rendu comme une seule image. C'est plus
     robuste qu'une superposition, qui devrait deviner l'emplacement du cadre a chaque
     taille d'ecran — et qui ne saurait pas poser un reflet de verre PAR-DESSUS le portrait.
     Ici, la page ne fait que changer une adresse. */
  var genIdCustomize = new URLSearchParams(location.search).get('id');
  var portraitCliente = null;

  /** Numero de rendu du compositeur. A MONTER des que le decor change (voir viewerSrc). */
  var RENDU = '2';

  /** Taille choisie, dans la forme attendue par le serveur : « 12 × 16 » -> « 12x16 ».
   *  C'est la meme normalisation que celle envoyee au panier — les deux doivent coller,
   *  sinon on montrerait un cadrage et on en imprimerait un autre. */
  function tailleCourante() {
    var s = PRICING[state.format].sizes[state.sizeIdx];
    return s['in'].replace(/\s/g, '').replace('×', 'x');
  }

  /** Support demande au compositeur, selon le format et le cadre choisis. */
  function effetCourant() {
    if (state.frame === 'black') return state.format === 'poster' ? 'frame-black_glass' : 'frame-black';
    if (state.frame === 'walnut') return state.format === 'poster' ? 'frame-walnut_glass' : 'frame-walnut';
    return state.format === 'poster' ? 'paper-unroll' : 'canvas-mockup';
  }

  /** Visuel d'origine, garde comme repli : jamais de cadre vide si le compositeur flanche. */
  function replisStatique() {
    var glass = state.format === 'poster' ? '_glass' : '';
    if (state.frame === 'black') return ''+(window.DESPI_ASSET_BASE||'')+'dp-img-renders-frame-black' + glass + '.jpg';
    if (state.frame === 'walnut') return ''+(window.DESPI_ASSET_BASE||'')+'dp-img-renders-frame-walnut' + glass + '.jpg';
    return state.format === 'poster' ? ''+(window.DESPI_ASSET_BASE||'')+'dp-img-renders-paper-unroll.jpg' : ''+(window.DESPI_ASSET_BASE||'')+'dp-img-renders-canvas-mockup.jpg';
  }

  function viewerSrc() {
    // sans identifiant de portrait, on ne peut rien composer : on garde l'ancien visuel
    if (!genIdCustomize || !window.despiApi) return replisStatique();
    // en numerique seul, aucun support physique : le fichier lui-meme est le produit
    if (state.digitalOnly) {
      return portraitCliente
        ? window.despiApi.image(portraitCliente, VIEWER ? VIEWER.clientWidth : 375)
        // rien plutot que le visage d'une inconnue : ce repli montrait
        // `demo-portrait-web.jpg` tant que le portrait n etait pas resolu
        : "data:image/svg+xml,%3Csvg%20xmlns='http://www.w3.org/2000/svg'/%3E";
    }
    /* `v` — LE NUMERO DE RENDU, ET IL FAUT LE MONTER A CHAQUE FOIS QUE LE VISUEL CHANGE.
       Ces images sont servies en `immutable` pour un an : sans ce numero, un navigateur
       ayant deja vu la page ne redemande JAMAIS le fichier. Constate en direct — le serveur
       renvoyait bien le nouveau decor, et l'ecran montrait toujours l'ancien. Turn Me Royal
       a la meme chose (`v=2.4.0-6`) : ce n'est pas un detail, c'est ce qui rend une
       correction visible. La taille reste transmise pour le jour ou un decor s'y adapterait
       ; aujourd'hui le compositeur l'ignore, l'ouverture d'un decor photographique est fixe. */
    return window.despiApi.base + '/api/customize/preview'
      + '?generationId=' + encodeURIComponent(genIdCustomize)
      + '&effect=' + effetCourant()
      + '&format=' + encodeURIComponent(tailleCourante())
      + '&v=' + RENDU;
  }

  function render() {
    /* Si la taille choisie rend le cadre courant indisponible, on revient a « sans cadre »
       AVANT de dessiner. Sans ce retour, la cliente resterait sur un cadre grise, avec un
       prix affiche pour un produit qu'elle ne peut pas commander. */
    if (estIndisponible(state.format, state.sizeIdx, state.frame)) state.frame = 'none';
    if (VIEWER) {
      var src = viewerSrc();
      if (VIEWER.getAttribute('src') !== src) {
        // si la composition echoue, on retombe sur le visuel d'origine plutot que sur une
        // image cassee — un achat ne doit jamais buter sur un mockup
        VIEWER.onerror = function () { VIEWER.onerror = null; VIEWER.src = replisStatique(); };
        /* Le fond d attente ne se leve qu une fois l image VRAIMENT arrivee.
           Avant, la page livrait le rendu de demonstration comme visuel initial : pendant
           une seconde, la cliente voyait le portrait d une inconnue a la place du sien. Un
           fond neutre dit « ca arrive » ; un autre visage dit « ce n est pas le mien ». */
        VIEWER.onload = function () {
          var boite = VIEWER.closest('[data-flow-viewer-boite]');
          if (boite) boite.classList.remove('dp-viewer-attente');
        };
        VIEWER.src = src;
      }
    }
    // formats
    document.querySelectorAll('[data-flow-formats] button').forEach(function (b) {
      var sel = b.getAttribute('data-format') === state.format;
      b.setAttribute('aria-pressed', sel);
      b.querySelector('[data-card]').className = 'block h-full overflow-hidden rounded-lg transition-colors ' +
        (sel ? 'bg-accent-primary-muted border border-accent-primary-muted-hover' : 'bg-bg-primary border border-border-subtle hover:border-border-primary');
      b.querySelector('[data-ring]').classList.toggle('hidden', !sel);
    });
    // frames (prix par format)
    var fp = PRICING[state.format].framePrice;
    document.querySelectorAll('[data-flow-frames] button').forEach(function (b) {
      var f = b.getAttribute('data-frame');
      var horsVente = estIndisponible(state.format, state.sizeIdx, f);
      var sel = f === state.frame && !horsVente;
      b.setAttribute('aria-pressed', sel);
      b.disabled = horsVente;
      b.classList.toggle('dp-indispo', horsVente);
      var pastille = b.querySelector('[data-dp-soldout]');
      if (horsVente && !pastille) {
        pastille = document.createElement('span');
        pastille.setAttribute('data-dp-soldout', '');
        pastille.className = 'dp-soldout';
        pastille.textContent = 'Sold out';
        b.appendChild(pastille);
      } else if (!horsVente && pastille) {
        pastille.remove();
      }
      b.querySelector('[data-card]').className = 'block h-full overflow-hidden rounded-lg transition-colors ' +
        (sel ? 'bg-accent-primary-muted border border-accent-primary-muted-hover' : 'bg-bg-primary border border-border-subtle hover:border-border-primary');
      b.querySelector('[data-ring]').classList.toggle('hidden', !sel);
      var priceEl = b.querySelector('[data-frame-price]');
      if (priceEl) priceEl.textContent = '+$' + fp;
    });
    var woodLbl = document.querySelector('[data-frame-wood-label]');
    var woodImg = document.querySelector('[data-frame-wood-img]');
    if (woodLbl) woodLbl.textContent = WOOD_META[state.format].label;
    if (woodImg && woodImg.getAttribute('src') !== WOOD_META[state.format].img) woodImg.src = WOOD_META[state.format].img;
    /* Plus de basculement pouces/centimetres : le trafic est americain, le centimetre
       ne servait personne et occupait la place la plus visible du bloc des tailles. Un
       bouton « Size guide » l'a remplace. `state.unit` reste a 'in' partout. */
    renderSizes();
    // digital toggle (design TMR : track bg-bg-tertiary, knob translate-x-[22px])
    var tgl = document.querySelector('[data-flow-toggle]');
    var knob = document.querySelector('[data-flow-knob]');
    tgl.classList.toggle('bg-bg-tertiary', state.digitalOnly);
    tgl.classList.toggle('bg-border-strong', !state.digitalOnly);
    knob.style.translate = state.digitalOnly ? '22px 0' : '';
    // selecteurs grises et incliquables quand digital only
    var selWrap = document.querySelector('[data-flow-selectors]');
    if (selWrap) {
      selWrap.setAttribute('aria-hidden', state.digitalOnly ? 'true' : 'false');
      selWrap.style.opacity = state.digitalOnly ? '0.4' : '';
      selWrap.style.pointerEvents = state.digitalOnly ? 'none' : '';
    }
    // summary + CTA
    var s = PRICING[state.format].sizes[state.sizeIdx];
    var sizeLabel = state.unit === 'in' ? s.in : s.cm;
    var sum1 = document.querySelector('[data-flow-summary]');
    var sum2 = document.querySelector('[data-flow-summary2]');
    if (state.digitalOnly) {
      sum1.textContent = 'Digital file only';
      sum2.textContent = 'High-res download';
    } else {
      sum1.textContent = (state.format === 'poster' ? 'Poster' : 'Canvas') + ' - ' + frameLabel();
      sum2.textContent = sizeLabel + ' - digital included';
    }
    document.querySelector('[data-flow-cart-label]').textContent = 'Add to cart - ' + money(total());
  }

  document.querySelector('[data-flow-formats]').addEventListener('click', function (e) {
    var b = e.target.closest('button[data-format]');
    if (!b) return;
    state.format = b.getAttribute('data-format');
    if (state.sizeIdx >= PRICING[state.format].sizes.length) state.sizeIdx = 0;
    // taille par défaut : la même dimension si dispo, sinon 1re
    render();
  });
  document.querySelector('[data-flow-frames]').addEventListener('click', function (e) {
    var b = e.target.closest('button[data-frame]');
    if (!b) return;
    state.frame = b.getAttribute('data-frame');
    render();
  });
  sizesGrid.addEventListener('click', function (e) {
    var b = e.target.closest('button[data-size]');
    if (!b) return;
    state.sizeIdx = parseInt(b.getAttribute('data-size'), 10);
    render();
  });
  document.querySelector('[data-flow-digital]').addEventListener('change', function (e) {
    state.digitalOnly = e.target.checked;
    render();
  });
  document.querySelector('[data-flow-cart]').addEventListener('click', function () {
    var conf = PRICING[state.format];
    var s = conf.sizes[state.sizeIdx];
    var item = {
      // identifiant du portrait et configuration : c'est ce que le serveur transformera
      // en article achetable, et ce que l'imprimeur lira au moment de la commande
      generationId: new URLSearchParams(location.search).get('id')
        || (window.despiCart && window.despiCart.lastGeneration) || null,
      size: s['in'].replace(/\s|×/g, function (c) { return c === '×' ? 'x' : ''; }),
      format: state.format,
      frame: state.frame,
      sizeIn: s['in'], sizeCm: s.cm,
      price: total(),
      old: state.digitalOnly ? DIGITAL_ONLY : s.old + (state.frame !== 'none' ? conf.framePrice : 0),
      digitalOnly: state.digitalOnly,
      frameCost: (state.digitalOnly || state.frame === 'none') ? 0 : conf.framePrice,
      frameLabel: frameLabel(),
      // Vignette du panier : le PORTRAIT, jamais le support. Les nouveaux mockups ont leur
      // zone d'image vide (le portrait est superpose en CSS) : y envoyer `viewerSrc()`
      // afficherait un cadre vide dans le panier. Et de toute facon, dans un panier, ce que
      // la cliente doit reconnaitre c'est son portrait, pas le type de papier.
      img: portraitCliente || viewerSrc()
    };
    try { localStorage.setItem('despiCart', JSON.stringify([item])); } catch (e) {}
    if (window.despiPaintCart) window.despiPaintCart();

    /* DROIT AU PAIEMENT. Avant, ce bouton se contentait d'ajouter au panier et d'afficher
       « Added to cart » : la cliente devait ensuite trouver l'icone du panier, l'ouvrir,
       puis cliquer un second bouton. Trois gestes pour une intention deja exprimee, sur un
       parcours ou 100 % du trafic vient d'une publicite. On l'emmene donc au checkout.

       Le panier reste rempli quoi qu'il arrive (ligne ci-dessus) : si la creation de
       l'article echoue, elle retrouve son article et peut repartir du panier. */
    if (!item.generationId || !window.despiApi) { window.despiToast('Added to cart'); return; }

    var btn = document.querySelector('[data-flow-cart]');
    var libelle = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Preparing your order…'; }

    window.despiApi.checkout([{
      generationId: item.generationId,
      format: item.format,
      frame: item.frame,
      size: item.size,
      digitalOnly: item.digitalOnly,
      quantity: 1,
    }]).catch(function (err) {
      if (btn) { btn.disabled = false; btn.textContent = libelle; }
      // meme table de messages que le reste du parcours : un refus doit se lire, pas se deviner
      var info = window.despiMessageErreur
        ? window.despiMessageErreur(err)
        : { msg: 'Checkout unavailable, please try again' };
      window.despiToast(info.msg);
    });
  });

  /* ---------------------------------------------- agrandir l'apercu

     Le bouton loupe existait dans le markup repris de la maquette, mais AUCUN script ne
     l'ecoutait : il ne faisait rien depuis le premier jour (verifie — zero occurrence de
     « zoom » dans les cinq scripts du theme). Sur une page ou l'objection numero un est la
     ressemblance, regarder son portrait en grand n'est pas un confort, c'est l'argument.

     On redemande une image PLUS LARGE au compositeur plutot que d'etirer les pixels deja
     affiches : agrandir l'apercu montrerait du flou precisement la ou la cliente cherche
     le detail. */
  (function agrandissement() {
    var bouton = document.querySelector('[aria-label="Zoom in on preview"]');
    if (!bouton || !VIEWER) return;
    var ouvert = null;

    function fermer() {
      if (!ouvert) return;
      var n = ouvert; ouvert = null;
      document.body.style.overflow = '';
      document.removeEventListener('keydown', surTouche);
      n.remove();
      bouton.focus();
    }
    function surTouche(e) { if (e.key === 'Escape') fermer(); }

    bouton.addEventListener('click', function () {
      if (ouvert) return;
      // 2x la largeur d'affichage, plafonne : au-dela le compositeur travaille pour rien
      /* On agrandit LE PORTRAIT, pas le mockup. L'objection numero un du marche est la
         ressemblance : ce que la cliente veut inspecter c'est le visage, pas le cadre. Et
         le compositeur ne sait pas rendre plus grand — lui ajouter une largeur ne ferait
         que casser son cache pour resservir la meme image. Le portrait, lui, passe par le
         redimensionneur de Supabase, qui sait vraiment monter en taille. */
      var large = Math.min(1600, Math.round((window.innerWidth || 800) * (window.devicePixelRatio || 1)));
      var src = (portraitCliente && window.despiApi && window.despiApi.image)
        ? window.despiApi.image(portraitCliente, large)
        : VIEWER.getAttribute('src');

      ouvert = document.createElement('div');
      ouvert.className = 'dp-zoom';
      ouvert.setAttribute('role', 'dialog');
      ouvert.setAttribute('aria-modal', 'true');
      ouvert.setAttribute('aria-label', 'Your portrait, enlarged');
      ouvert.innerHTML =
        '<button type="button" class="dp-zoom-fermer" aria-label="Close">&times;</button>'
        + '<img src="' + src + '" alt="Your portrait, enlarged" draggable="false">';
      ouvert.addEventListener('click', function (e) {
        // le fond ET la croix ferment ; l'image, non — on y regarde le detail
        if (e.target === ouvert || e.target.closest('.dp-zoom-fermer')) fermer();
      });
      document.body.appendChild(ouvert);
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', surTouche);
      ouvert.querySelector('.dp-zoom-fermer').focus();
    });
  })();

  /* ---------------------------------------------- guide des tailles et onglets

     Trois petits mecanismes de page, volontairement sans dependance : la CSS du theme est
     pre-compilee et les classes a valeur arbitraire y sont ignorees en silence, donc tout
     l'habillage vit dans `tmr-extra.css` et le JavaScript ne fait que poser des attributs. */

  (function guideDesTailles() {
    var ouvre = document.querySelector('[data-flow-sizeguide]');
    var modale = document.querySelector('[data-dp-overlay="sizeguide"]');
    if (!ouvre || !modale) return;

    /* L'image du guide n'est pas encore fournie : tant qu'elle manque, on montre le
       tableau des tailles reelles plutot qu'une image cassee. Le jour ou le fichier
       arrive dans le theme, il s'affiche et le tableau s'efface tout seul. */
    var img = modale.querySelector('[data-dp-sizeguide-img]');
    var table = modale.querySelector('[data-dp-sizetable]');
    if (img) {
      img.addEventListener('error', function () {
        img.hidden = true;
        if (table) table.hidden = false;
      });
    }

    var rendu = null;
    function ouvrir() {
      rendu = document.activeElement;
      modale.hidden = false;
      document.body.style.overflow = 'hidden';
      var f = modale.querySelector('.dp-overlay-fermer');
      if (f) f.focus();
    }
    function fermer() {
      modale.hidden = true;
      document.body.style.overflow = '';
      if (rendu && rendu.focus) rendu.focus();   // on rend le focus a qui l'avait
    }
    ouvre.addEventListener('click', ouvrir);
    modale.addEventListener('click', function (e) {
      if (e.target.closest('[data-dp-close]')) fermer();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modale.hidden) fermer();
    });
  })();

  /* ------------------------------------------------ prechauffage des six supports

     La cliente change de format et de cadre plusieurs fois avant de choisir. Chaque
     changement demande une image composee au serveur : au premier appel, entre 0,8 et
     2,4 s mesurees, pendant lesquelles l'ancien visuel reste affiche — on croit que le
     clic n'a rien fait. Ensuite le CDN repond en quelques dizaines de millisecondes.

     On demande donc les six d'avance, une fois la page posee. Turn Me Royal fait de meme
     (leur `customizePreviewPrewarmUrls`). `requestIdleCallback` attend que le navigateur
     n'ait plus rien d'urgent : le prechauffage ne doit jamais retarder l'affichage. */
  (function prechauffer() {
    if (!genIdCustomize || !window.despiApi) return;
    var lancer = function () {
      ['paper-unroll', 'canvas-mockup', 'frame-black', 'frame-walnut',
       'frame-black_glass', 'frame-walnut_glass'].forEach(function (e, i) {
        // en file, pas en rafale : six images simultanees sur une 4G encombrent le reseau
        // au moment ou la page finit de se peindre
        setTimeout(function () {
          var img = new Image();
          img.decoding = 'async';
          img.src = window.despiApi.base + '/api/customize/preview'
            + '?generationId=' + encodeURIComponent(genIdCustomize)
            + '&effect=' + e + '&format=' + encodeURIComponent(tailleCourante())
            + '&v=' + RENDU;
        }, i * 250);
      });
    };
    if (window.requestIdleCallback) window.requestIdleCallback(lancer, { timeout: 2500 });
    else setTimeout(lancer, 1200);
  })();

  (function ongletsInfo() {
    var tabs = document.querySelector('.dp-info-tabs');
    if (!tabs) return;
    tabs.addEventListener('click', function (e) {
      var b = e.target.closest('[data-dp-tab]');
      if (!b) return;
      var cible = b.getAttribute('data-dp-tab');
      tabs.querySelectorAll('[data-dp-tab]').forEach(function (x) {
        x.setAttribute('aria-selected', x === b ? 'true' : 'false');
      });
      document.querySelectorAll('[data-dp-panel]').forEach(function (p) {
        p.hidden = p.getAttribute('data-dp-panel') !== cible;
      });
    });
  })();

  render();
})();

/* ---------- order.html : panier ---------- */
  (function () {
    var itemsUl = document.querySelector('[data-order-items]');
    if (!itemsUl) return;
    var DELIVERY = { express: 29, standard: 0 };
    var ostate = { delivery: 'express' };
    var cart = [];
    try { cart = JSON.parse(localStorage.getItem('despiCart') || '[]'); } catch (e) {}
    if (!cart.length) {
      cart = [{ format: 'poster', frame: 'walnut', sizeIn: '12 \u00d7 16', sizeCm: '30 \u00d7 40',
                price: 94, old: 159, digitalOnly: false, frameCost: 50, img: ''+(window.DESPI_ASSET_BASE||'')+'dp-img-renders-frame-walnut_glass.jpg' }];
    }

    function money(n) { return '$' + n; }
    function frameTxt(f) { return f === 'none' ? 'No frame' : (f === 'black' ? 'Black frame' : 'Walnut frame'); }

    function renderItems() {
      document.querySelector('[data-order-count]').textContent = 'Your cart (' + cart.length + ')';
      document.querySelector('[data-order-empty]').classList.toggle('hidden', cart.length > 0);
      var ds = document.querySelector('[data-order-delivery-section]');
      if (ds) ds.style.display = cart.length ? '' : 'none';
      itemsUl.innerHTML = cart.map(function (it, i) {
        var title = it.digitalOnly ? 'Digital file' : (it.format === 'poster' ? 'Poster' : 'Canvas');
        var subtitle = it.digitalOnly ? 'High-res download' : it.sizeIn + ' \u00b7 ' + frameTxt(it.frame);
        return '<li class="flex items-stretch gap-3 rounded-xl border border-border-subtle bg-bg-primary p-3">' +
          '<div class="relative w-[112px] h-[112px] lg:w-[132px] lg:h-[132px] shrink-0 rounded-md overflow-hidden bg-bg-secondary border border-border-subtle">' +
            '<img alt="" class="object-cover" style="position:absolute;height:100%;width:100%;inset:0" src="' + it.img + '">' +
          '</div>' +
          '<div class="flex-1 min-w-0 flex flex-col">' +
            '<div class="flex items-start justify-between gap-2">' +
              '<p class="text-sm lg:text-base font-semibold text-text-primary leading-5 pr-1">' + title + '</p>' +
              '<div class="flex items-baseline gap-2 shrink-0">' +
                '<span class="text-base lg:text-lg font-semibold text-text-primary">' + money(it.price) + '</span>' +
                (it.old > it.price ? '<span class="text-xs lg:text-sm text-text-tertiary line-through">' + money(it.old) + '</span>' : '') +
              '</div></div>' +
            '<p class="text-xs lg:text-sm text-text-tertiary leading-5 mt-1">' + subtitle + '</p>' +
            (it.digitalOnly ? '' :
            '<p class="flex items-center gap-1.5 text-xs lg:text-sm text-text-secondary leading-5 mt-1">' +
              '<svg class="shrink-0 text-text-tertiary" width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M14 2H7a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"></path><path d="M14 2v5h5M9 13h6M9 17h4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"></path></svg>' +
              'Instant digital download added</p>') +
            '<div class="mt-auto pt-2 flex items-center gap-4 text-sm text-text-tertiary">' +
              '<button type="button" data-order-remove="' + i + '" class="inline-flex items-center gap-1 hover:text-text-primary transition-colors cursor-pointer">' +
                '<svg class="size-3.5" width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"></path></svg>Remove</button>' +
              '<a href="customize.html" class="inline-flex items-center gap-1 hover:text-text-primary transition-colors">' +
                '<svg class="size-3.5" width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L6.832 19.82a4.5 4.5 0 0 1-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 0 1 1.13-1.897L16.863 4.487Zm0 0L19.5 7.125" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>Edit</a>' +
            '</div></div></li>';
      }).join('');
    }

    function renderSummary() {
      var subtotal = cart.reduce(function (a, it) { return a + it.old; }, 0);
      var actual = cart.reduce(function (a, it) { return a + it.price; }, 0);
      var discount = subtotal - actual;
      var delivery = cart.length ? DELIVERY[ostate.delivery] : 0;
      var totalV = actual + delivery;
      var printOld = cart.reduce(function (a, it) { return a + it.old - (it.frameCost || 0); }, 0);
      var pct = printOld > 0 ? Math.round(discount / printOld * 100) : 0;
      document.querySelector('[data-order-subtotal]').textContent = money(subtotal);
      document.querySelector('[data-order-discount]').textContent = '\u2212' + money(discount);
      document.querySelector('[data-order-delivery-label]').textContent = ostate.delivery === 'express' ? 'Express delivery' : 'Standard delivery';
      document.querySelector('[data-order-delivery-price]').textContent = delivery ? money(delivery) : 'Free';
      document.querySelector('[data-order-total]').textContent = money(totalV);
      document.querySelector('[data-order-savings]').style.display = discount > 0 ? '' : 'none';
      document.querySelector('[data-order-save-amount]').textContent = money(discount);
      document.querySelector('[data-order-save-pct]').textContent = pct;
      document.querySelectorAll('[data-order-checkout-label]').forEach(function (el) {
        el.textContent = 'Continue to checkout - ' + money(totalV);
      });
      document.querySelectorAll('[data-order-delivery] label').forEach(function (lb) {
        var sel = lb.getAttribute('data-delivery') === ostate.delivery;
        lb.className = 'relative flex items-center justify-between gap-3 rounded-xl border px-4 py-4 cursor-pointer transition-colors ' +
          (sel ? 'border-2 border-accent-primary bg-accent-primary-muted/60' : 'border border-border-subtle bg-bg-primary hover:border-border-primary');
        var radio = lb.querySelector('[data-radio]');
        radio.className = 'mt-0.5 size-5 rounded-full border-2 inline-flex items-center justify-center shrink-0 ' + (sel ? 'border-text-primary' : 'border-border-strong');
        radio.innerHTML = sel ? '<span class="size-2.5 rounded-full bg-text-primary"></span>' : '';
        lb.querySelector('input').checked = sel;
      });
    }

    itemsUl.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-order-remove]');
      if (!rm) return;
      cart.splice(parseInt(rm.getAttribute('data-order-remove'), 10), 1);
      try { localStorage.setItem('despiCart', JSON.stringify(cart)); } catch (err) {}
      renderItems(); renderSummary();
    });
    document.querySelector('[data-order-delivery]').addEventListener('click', function (e) {
      var lb = e.target.closest('label[data-delivery]');
      if (!lb) return;
      ostate.delivery = lb.getAttribute('data-delivery');
      renderSummary();
    });
    // page Order archivee, mais on la branche pour qu'elle ne mente pas si elle ressort
    document.querySelectorAll('[data-order-checkout]').forEach(function (b) {
      b.addEventListener('click', function () {
        var articles = cart.filter(function (i) { return i.generationId; });
        if (!articles.length || !window.despiApi) {
          window.despiToast('Your cart is empty');
          return;
        }
        b.disabled = true;
        window.despiApi.checkout(articles).catch(function () {
          b.disabled = false;
          window.despiToast('Checkout unavailable, please try again');
        });
      });
    });

    renderItems();
    renderSummary();
  })();

